<!--
 * @Author: yezi
 * @Date: 2020-06-23 17:01:41
 * @LastEditors: yezi
 * @LastEditTime: 2020-07-16 16:45:47
 * @Description:
-->
<template>
 <div class="content">
     <div class="cItem">
      <div style="display:flex;align-items: center; padding: 0 .3rem" @click="back">
        <van-icon name="arrow-left" size="22px" style="margin-right:0.1rem"/>
        <P class="title">{{title}}</P>
      </div>
      <div v-html="content" style="margin-top: 0.4rem;"></div>
    </div>
 </div>
</template>

<script>
export default {
  name: 'directionsDetail',
  components: {},
  data () {
    return {
      content: '',
      title: this.$route.query.title
    }
  },
  created () {
    this.content = localStorage.getItem('content')
    this.content = this.content.replace(/<img/g, "<img style='max-width:100%;height:auto;'")
    localStorage.clear()
  },
  methods: {
    back () {
      this.$router.back()
    }
  }
}
</script>

<style scoped>
.content {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  width: 100%;
}
.cItem p {
  color: #121212;
  font-size: 0.34rem;
  font-weight: bold;
}
</style>
